module.exports = __webpack_public_path__ + "static/img/Bachelor_010453.2ef7bb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010453.jpg
// module id = 168
// module chunks = 0